export function extractIds(brands) {
  const ids = [];
  brands.forEach((brand) => {
    brand?.locations.forEach((location) => {
      ids.push(location?._id);
    });
  });
  return ids;
}
